import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { INutrientLivestockPlan } from './nutrient-livestock-plan.model';

@Injectable()
export class NutrientLivestockPlanService {
  constructor(private apiService: ApiService) {}

  saveLivestockPlan(plan: INutrientLivestockPlan): Promise<any> {
    return this.apiService.post('v1/nutrient-livestock-plans', plan);
  }
}
